/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type ChangeState = 'NONE' | 'PENDING' | 'RUNNING' | unhandledEnumCase;

export type BetaAccessRollout = {
  id: number;
  rolloutId: number;
  portalId: number;
  hubId?: number;
  approved: boolean;
  isGimmie?: boolean;
  enrollId?: number;
  requester?: string;
  requesterId?: number;
  approvedAt?: number;
  requestedAt?: number;
  hublet?: string;
  betaAccessType?: BetaAccessType;
  enrollType?: EnrollType;
  rollout?: RolloutWithName;
  hubType?: HubType;
  currentStatus?: EnrollStatus;
  currentStatusUpdatedAt?: number;
  contactId?: number;
  organizationId?: number;
  subscriptions: Default<string[]>;
  isActivated: Default<boolean>;
  pageVisited: Default<boolean>;
  followedUp: Default<boolean>;
  revisionId: Default<number>;
  changeState: Default<ChangeState>;
  processingDeployable?: string;
};

export type BetaAccessType = 'PUBLIC' | 'PRIVATE' | unhandledEnumCase;

export type EnrollType =
  | 'USERS_AND_PORTALS'
  | 'USERS_ONLY'
  | 'PORTALS_ONLY'
  | 'ORGANIZATIONS_ONLY'
  | unhandledEnumCase;

export type GenericBetaAccessRolloutRequest = {
  rolloutId: number;
  portalId: number;
  hubId?: number;
  enrollId?: number;
  enrollType?: EnrollType;
  betaAccessType?: BetaAccessType;
  needsUngating: Default<boolean>;
  shouldUpdateMultiAccounts: Default<boolean>;
};

export type RolloutState =
  | 'DRAFT'
  | 'IN_DEVELOPMENT'
  | 'ALPHA'
  | 'PRIVATE_BETA'
  | 'PUBLIC_BETA'
  | 'PHASED_ROLLOUT'
  | 'LIVE'
  | 'UPCOMING_SUNSET'
  | 'SUNSET'
  | 'DEPRIORITIZED'
  | 'FINAL'
  | unhandledEnumCase;

export type RolloutType =
  | 'INITIAL_RELEASE'
  | 'ADDITIONAL_FUNCTIONALITY'
  | 'REDESIGN'
  | 'PRICING_CHANGE'
  | 'PERMISSIONS_CHANGE'
  | 'BREAKING_CHANGE'
  | 'SUNSET'
  | unhandledEnumCase;

export type SuccessCriteriaCore = { title: string; description: string };

export namespace ComHubspotFeatureRolloutsCoreModelsRollouts {
  export type UpdateEnrollTypeRequest = {
    requestToEnable: GenericBetaAccessRolloutRequest;
    requestToDisable: GenericBetaAccessRolloutRequest;
  };
}

export type RolloutWithName = {
  username?: string;
  fullName?: string;
  uxDriUsername?: string;
  uxDriFullName?: string;
  id: number;
  primaryFeatureId: number;
  ownerId: number;
  productConfigDriId?: number;
  uxDriId?: number;
  optinId?: number;
  name: string;
  gateName?: string;
  pitIdeaIds: Default<number[]>;
  ideasForumPostIds: Default<number[]>;
  description?: string;
  reason?: string;
  functionality?: string;
  state: RolloutState;
  /** @deprecated */
  launchAt?: number;
  /** @deprecated */
  publicBetaStartAt?: number;
  /** @deprecated */
  privateBetaStartAt?: number;
  products: Default<string[]>;
  audiences: Default<string[]>;
  rolloutType?: RolloutType;
  /** @deprecated */
  openToCustomerUngate: Default<boolean>;
  updatedAt?: number;
  communityForumLink?: string;
  kbArticleLink?: string;
  additionalLink?: string;
  additionalLinkTitle?: string;
  enrollType?: EnrollType;
  marketingReleaseAt?: number;
  contact?: string;
  globalizationConsiderations?: string;
  isGlobalizationConsiderationsVerified?: boolean;
  localizedScreenshotsLink?: string;
  hasAiFeature?: boolean;
  /** @deprecated */
  usageFrequency?: UsageFrequency;
  /** @deprecated */
  behaviorChangeType?: BehaviorChangeType;
  /** @deprecated */
  configurationType?: ConfigurationType;
  impactLevel?: number;
  classification?: string;
  frequencyOfUse?: FrequencyOfUse;
  userImpact?: UserImpact;
  deliveryMethod?: DeliveryMethod;
  spotlightTag?: string;
  createdAt?: number;
  successCriteria?: SuccessCriteriaCore;
  betaPaused: Default<boolean>;
  betaRequestCap: Default<number>;
  tentativeFinalStageDate?: number;
  mainHub?: string;
  useCases: Default<string[]>;
  areLanguagesSupported?: boolean;
  isFeatureFunctional?: boolean;
  isRegionCompatible?: boolean;
  parentChildAssociationStatus?: ParentChildAssociationStatus;
  isLawyersBeta: Default<boolean>;
  nonAmplitudeActivationEvent?: string;
  internalQuestionsSlackChannelId?: string;
  isSensitive: Default<boolean>;
};

export type BetaAccessRolloutResponse = {
  betaAccessRollout?: BetaAccessRollout;
};

export type EmptyResponse = {};

export type ExternalBetaAccessRolloutRequest = {
  rolloutId: number;
  enrollType: EnrollType;
  needsUngating: Default<boolean>;
  shouldUpdateMultiAccounts: Default<boolean>;
};

export namespace ComHubspotFeatureRolloutsCoreModelsRolloutsChirp {
  export type UpdateEnrollTypeRequest = {
    request: ComHubspotFeatureRolloutsCoreModelsRollouts.UpdateEnrollTypeRequest;
  };
}

export type BehaviorChangeType = 'NONE' | 'SMALL' | 'LARGE' | unhandledEnumCase;

export type ConfigurationType =
  | 'REQUIRED'
  | 'CONFIGURABLE'
  | 'AUTOMATIC'
  | unhandledEnumCase;

export type DeliveryMethod =
  | 'MANUAL'
  | 'CONFIGURABLE'
  | 'AUTOMATIC'
  | unhandledEnumCase;

export type EnrollStatus =
  | 'REQUESTED'
  | 'APPROVED'
  | 'REJECTED'
  | 'LEFT'
  | unhandledEnumCase;

export type FrequencyOfUse =
  | 'RARE'
  | 'OCCASIONAL'
  | 'FREQUENT'
  | unhandledEnumCase;

export type HubType =
  | 'CUSTOMER'
  | 'INTERNAL'
  | 'INTERNAL_CUSTOMER_DATA'
  | 'ACCEPTANCE_TEST'
  | 'EMPLOYEE_FAF'
  | 'NON_EMPLOYEE_FAF'
  | 'EXPLOYEE_FAF'
  | 'DEVELOPER_TEST'
  | 'PARTNER_DEMO'
  | 'EDUCATION_PARTNER'
  | 'SANDBOX'
  | unhandledEnumCase;

export type ParentChildAssociationStatus =
  | 'PARENT'
  | 'CHILD_UNMERGED'
  | 'CHILD_MERGED'
  | 'CHILD_MERGING'
  | unhandledEnumCase;

export type UsageFrequency = 'LOW' | 'MEDIUM' | 'HIGH' | unhandledEnumCase;

export type UserImpact =
  | 'NONE'
  | 'MODERATE'
  | 'MAJOR'
  | 'NOTICEABLE'
  | unhandledEnumCase;

export type EnrollRequestType = Requestify<ExternalBetaAccessRolloutRequest>;
export type EnrollResponseType = BetaAccessRolloutResponse;
export type EnrollErrorType = EmptyError & HubspotMetadata;
export const enrollRpc: ChirpAvroRpcDetails<
  EnrollRequestType,
  EnrollResponseType,
  EnrollErrorType,
  false
> = {
  serviceName: 'com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc',
  rpcName: 'enroll',
  auth: 'app',
  fingerprint: '59lJ_u1DNyJ-_T6XKFJ3NJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateEnrollTypeRequestType =
  Requestify<ComHubspotFeatureRolloutsCoreModelsRolloutsChirp.UpdateEnrollTypeRequest>;
export type UpdateEnrollTypeResponseType = EmptyResponse;
export type UpdateEnrollTypeErrorType = EmptyError & HubspotMetadata;
export const updateEnrollTypeRpc: ChirpAvroRpcDetails<
  UpdateEnrollTypeRequestType,
  UpdateEnrollTypeResponseType,
  UpdateEnrollTypeErrorType,
  false
> = {
  serviceName: 'com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc',
  rpcName: 'updateEnrollType',
  auth: 'app',
  fingerprint: 'IhTRrPGe4p29JMQePTNox5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type LeaveRequestType = Requestify<ExternalBetaAccessRolloutRequest>;
export type LeaveResponseType = EmptyResponse;
export type LeaveErrorType = EmptyError & HubspotMetadata;
export const leaveRpc: ChirpAvroRpcDetails<
  LeaveRequestType,
  LeaveResponseType,
  LeaveErrorType,
  false
> = {
  serviceName: 'com.hubspot.feature.rollouts.app.rpc.BetaAccessRolloutRpc',
  rpcName: 'leave',
  auth: 'app',
  fingerprint: '59lJ_u1DNyK9JMQePTNox5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
